import Datalayer from './data/Datalayer.esm.js';

class Analytics {
    /**
     * Creates a list with all the providers that will be used for analytics,
     * used before loading the providers
     */ prepare(providers) {
        for (const provider of providers){
            this.providers.push(provider);
        }
        this.isPrepared = true;
    }
    /**
     * @deprecated Instead of this use sendCustomEvent (Which doesnt require to setup DLV in GTM)
     */ async sendEvent(data, providers) {
        // If the providers aren't initialized yet, queue these events to execute later
        if (!this.isInitialized) {
            this.eventsQueue.push({
                data,
                providers
            });
            return;
        }
        const collection = [];
        for (const provider of this.providers){
            if (!providers) {
                if (provider.isActive) {
                    collection.push(provider.sendEvent(data));
                }
            } else {
                for (const pr of providers){
                    if (pr.name === provider.constructor.name) {
                        collection.push(provider.sendEvent(data));
                    }
                }
            }
        }
        return Promise.all(collection);
    }
    async sendCustomEvent(analyticEventName, data) {
        const genericEventName = 'generic_analytics_event';
        const dlvGenericEventName = 'generic_analytics_event_data';
        const datalayerObject = new Datalayer(genericEventName, {
            [dlvGenericEventName]: JSON.stringify({
                analyticEventName,
                data
            })
        });
        return this.sendEvent(datalayerObject);
    }
    constructor(){
        this.providers = [];
        this.eventsQueue = [];
        this.isInitialized = false;
        this.isPrepared = false;
        // Initialize the providers, effectively loading and executing their scripts
        this.initialize = ()=>{
            for (const provider of this.providers){
                provider.init();
            }
            this.isInitialized = true;
            if (this.eventsQueue.length) {
                this.eventsQueue.forEach(({ data, providers })=>{
                    this.sendEvent(data, providers);
                });
                this.eventsQueue = [];
            }
        };
    }
}

export { Analytics as default };
